import { client } from "shared/api/client";
import { toast } from "react-toastify";

export const getCountries = async () => {
  try {
    return await client.get("/api/countries/get-countries");
  } catch (error) {
    toast.error(error.response.data.message, { theme: "colored" });
  }
};
